<mat-toolbar [style.right.px]="contextualHelpService.contentInsetPx()">
  <span
    #appTitle
    routerLink="/"
    tabindex="0"
    [style.cursor]="'pointer'"
    (keydown.enter)="appTitle.click()"
    (keydown.space)="appTitle.click()">
    {{ 'wrapper.appTitle' | transloco }}
  </span>
  <span class="toolbar-spacer"></span>
  <span>{{ authService.getUserData()?.username }}</span>
  <app-notification-panel />
  <app-theme-picker [isEnforced]="themeService.isThemeEnforced()" />

  <button
    matIconButton
    class="help-toggle-btn"
    [class.is-active]="contextualHelpService.isOpen()"
    [attr.aria-label]="'wrapper.openHelpAriaLabel' | transloco"
    [attr.aria-pressed]="contextualHelpService.isOpen()"
    (click)="toggleHelp()">
    <mat-icon>{{ contextualHelpService.isOpen() ? 'help' : 'help_outline' }}</mat-icon>
  </button>

  <button matIconButton [matMenuTriggerFor]="menu" [attr.aria-label]="'wrapper.openUserMenuAriaLabel' | transloco">
    <mat-icon>account_circle</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    @if (authService.isConnected() === true) {
      <div
        class="user-menu-header"
        tabindex="0"
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()">
        <div class="user-full-name">
          {{ authService.getUserData()?.firstName }}
          {{ authService.getUserData()?.lastName }}
        </div>
        <div class="user-role-label">
          {{ 'wrapper.userRoleLabel' | transloco }}:
          {{ i18n.roleKey(authService.getSystemRole() || 'guest') | transloco }}
        </div>
      </div>
      <mat-divider />
      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        {{ 'wrapper.logoutAction' | transloco }}
      </button>
    } @else {
      <button mat-menu-item routerLink="/login">
        <mat-icon>login</mat-icon>
        {{ 'wrapper.loginAction' | transloco }}
      </button>
    }
    <mat-divider />
    @if (authService.hasSystemPermission('SYSTEM_READ_ALL')) {
      <button mat-menu-item routerLink="/admin/dashboard">
        <mat-icon>admin_panel_settings</mat-icon>
        {{ 'admin.dashboard' | transloco }}
      </button>
      <mat-divider />
    }
    <button mat-menu-item routerLink="/account">
      <mat-icon>person</mat-icon>
      {{ 'wrapper.accountAction' | transloco }}
    </button>
    <button mat-menu-item routerLink="/settings">
      <mat-icon>settings</mat-icon>
      {{ 'wrapper.settingsAction' | transloco }}
    </button>
    <mat-divider />
    <div mat-menu-item tabindex="0" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <app-language-switcher />
    </div>
  </mat-menu>
</mat-toolbar>

<div class="breadcrumb-container">
  <app-breadcrumb />
</div>

<div class="main-content">
  <router-outlet />
</div>

<app-footer />
